import React from "react";
import { apiService } from "../../../utils/api";
import { useParams, useNavigate } from "react-router-dom";
import { FaFileAlt, FaSearch, FaFilter, FaSortAmountDown, FaSortAmountUp, FaPlus, FaEye, FaDownload, FaTrash } from "react-icons/fa";

function SelectAudioExerciseLevel() {
  const [categories, setCategories] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const navigate = useNavigate();

  React.useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await apiService.getAudioExercises();
        setCategories(response.data);
        setIsLoading(false);
      } catch (error) {
        console.error(error);
      }
    };
    fetchCategories();
  }, []);

  const handleViewDocument = (id) => {
    navigate(`/select-audio-document/${id}`);
  };

  return (
    <div className="documents-container">
      <div className="section-header">
        <h2>Select Excerises Levels to give test</h2>
      </div>

      <div className="documents-grid">
        {categories.map((cat) => (
          <div key={cat.id} className="document-card" onClick={() => handleViewDocument(cat.id)}>
            <div className="document-icon">
              <FaFileAlt />
            </div>
            <div className="document-info">
              <h4>{cat.level}</h4>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default SelectAudioExerciseLevel;
